<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <section class="has-background-light">
      <br><h1 class="title is-4">ลงทะเบียนรับรถเข้าศูนย์ สาขา {{ branchSelected }}</h1>
    </section>
    <section class="hero has-background-light is-fullheight" v-show="!sendQRSuccess">
      <div class="hero-body-custom" >
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-5-tablet is-4-desktop is-3-widescreen">
              <div class="container"><br>
                <h3 class="title is-5">กรุณากรอกข้อมูล</h3>
                <p v-if="errors.length">
                  <ul>
                    <li v-for="error in errors" v-bind:key="error" class="has-text-danger">{{ error }}</li>
                  </ul><br>
                </p>

                <div class="field">
                  <label class="label">ลำดับที่</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ลำดับที่" v-model="carInfo.runNo">
                  </div>
                </div>

                <div class="field">
                  <label class="label">ชื่อลูกค้า</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ชื่อลูกค้า" v-model="carInfo.customerName">
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขตัวถัง</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขตัวถัง" v-model="carInfo.frameNo">
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขทะเบียน</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขทะเบียน" v-model="carInfo.licenseNo">
                  </div>
                </div>
                <div class="field">
                  <label class="label">วัน-เวลาที่คาดว่าจะเสร็จ</label>
                </div>
                <div class="columns">
                  <div class="column">
                    <div class="field">
                      <div class="control">
                        <input class="input" type="text" placeholder="วัน" v-model="carInfo.expectedDate">
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <div class="control">
                        <input class="input" type="text" placeholder="เวลา" v-model="carInfo.expectedTime">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="checkbox">
                    <input type="checkbox" v-model="carInfo.customerWait" >&nbsp;&nbsp;&nbsp;<b>ลูกค้ารอรับรถ</b>
                  </label>
                </div><br>
                <div class="field">
                  <label class="label">ลูกค้า "Drop and Go" ใส่เลขเอกสาร ZR-12</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขเอกสาร ZR-12" v-model="carInfo.zr12No">
                  </div>
                </div>
                <br>
                <button class="button is-success" v-on:click="submitCarInfo">{{ btn_action }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <article class="message is-success" v-show="sendQRSuccess">
      <div class="message-header">
        <p>ส่ง QR Code ไปที่ LINE Group Admin เรียบร้อยแล้ว</p>
      </div>
      <div class="message-body">
        <button class="button is-link" v-on:click="newCustomer">รับลูกค้าใหม่</button>
      </div>
    </article>
  </div>
</template>
<style>
.hero-body-custom {
  display: flex;
  padding: 0 !important;
}
.banner {
  text-align: center;
  background-color: #ededed;
}
input[type=checkbox] {
  padding: 10px;
          transform: scale(2);

  -webkit-transform: scale(2); /* Safari and Chrome */
     -moz-transform: scale(2); /* FF */
  /* Double-sized Checkboxes */
      -ms-transform: scale(2); /* IE */
       -o-transform: scale(2); /* Opera */
}

/* Might want to wrap a span around your checkbox text */
.checkboxtext {
  display: inline;
  /* Checkbox text */
  font-size: 110%;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'Home',
  beforeCreate () {
    // if (!this.$session.exists()) {
    //   this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    // } else {
    //   this.$liff.init({ liffId: this.$liffId_Service_Register }, function (data) {})
    // }
  },
  components: {
    QrcodeVue
  },
  data: () => ({
    urlconfirm: 'https://liff.line.me/1653760842-gQWZxLk9?',
    size: 200,
    registerSuccess: false,
    sendQRSuccess: false,
    errors: [],
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    branch: [],
    branchSelected: '',
    branchCode: '',
    carInfo: {
      runNo: '',
      branchId: '',
      customerName: '',
      frameNo: '',
      licenseNo: '',
      expectedDate: '',
      expectedTime: '',
      customerWait: false,
      zr12No: ''
    },
    carId: '',
    btn_action: 'Submit',
    updatedBy: ''
  }),
  async mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    let _this = this
    _this.updatedBy = this.$session.get('vgroup')
    _this.branch = this.$branchList
    // if (process.env.NODE_ENV === 'development') {
    //   this.getProfile_dev()
    // } else {
    //   this.getProfile()
    // }
    const queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    console.log(queryString)
    const params = new URLSearchParams(queryString)
    const branchCode = params.get('branchCode')
    _this.branchCode = branchCode
    _this.branch.map((item) => {
      _this.branchSelected = (item.id === _this.branchCode) ? item.name : _this.branchSelected
      return true
    })
    this.getToday()
  },
  methods: {
    getToday () {
      const date = new Date()
      this.carInfo.expectedDate = ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear()
    },
    newCustomer () {
      this.carInfo.runNo = ''
      this.carInfo.customerName = ''
      this.carInfo.frameNo = ''
      this.carInfo.licenseNo = ''
      this.carInfo.expectedDate = ''
      this.carInfo.expectedTime = ''
      this.carInfo.zr12No = ''
      this.carInfo.customerWait = false
      this.btn_action = 'Submit'
      this.errors = []
      this.registerSuccess = false
      this.sendQRSuccess = false
      this.getToday()
    },
    checkForm (e) {
      if (this.carInfo.customerName && this.carInfo.frameNo && this.carInfo.licenseNo) {
        return true
      }

      this.errors = []
      if (!this.carInfo.runNo) {
        this.errors.push('กรุณากรอกลำดับที่')
      }
      if (!this.carInfo.customerName) {
        this.errors.push('กรุณากรอกชื่อลูกค้า')
      }
      if (!this.carInfo.frameNo) {
        this.errors.push('กรุณากรอกเลขตัวถัง')
      }
      if (!this.carInfo.licenseNo) {
        this.errors.push('กรุณากรอกเลชทะเบียน')
      }
      if (!this.carInfo.expectedDate) {
        this.errors.push('กรุณากรอกวันที่คาดว่าจะเสร็จ')
      }
      if (!this.carInfo.expectedTime) {
        this.errors.push('กรุณากรอกเวลาที่คาดว่าจะเสร็จ')
      }

      e.preventDefault()
    },
    submitCarInfo (e) {
      let _this = this
      if (!this.checkForm(e)) {
        return false
      }
      _this.btn_action = 'Waiting...'
      _this.carInfo.branchId = _this.branchCode
      let params = {
        carInfo: _this.carInfo,
        updatedBy: _this.updatedBy
      }
      this.$axios
        .post(`${this.$apiUrl}setCarInfo`, params)
        .then(response => {
          _this.carId = response.data.carId
          _this.urlconfirm += `branchCode=${_this.branchCode}&carId=${_this.carId}`
          _this.registerSuccess = true
          if (_this.carInfo.zr12No === '') {
            if (process.env.NODE_ENV !== 'development') {
              _this.sendQRCodeToSA()
            } else {
              _this.sendQRSuccess = true
              _this.sendQRCodeToSA()
            }
          } else {
            _this.sendQRSuccess = true
          }
        })
    },
    sendQRCodeToSA () {
      let _this = this
      console.log(_this.carInfo)
      this.$axios
        .get(`${this.$apiUrl}sendQRCodeToSA?customerName=${_this.carInfo.customerName}&pictureUrl=${_this.profile.pictureUrl}&licenseNo=${_this.carInfo.licenseNo}&frameNo=${_this.carInfo.frameNo}&runNo=${_this.carInfo.runNo}&branchCode=${_this.branchCode}&carId=${_this.carId}`)
        .then(response => {
          _this.sendQRSuccess = true
        })
    },
    openWindow () {
      this.$liff.openWindow({
        url: 'https://developers.line.me/en/docs/liff/overview/'
      })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([
        {
          type: 'text',
          text: 'You/\'ve successfully sent a message! Hooray!'
        },
        {
          type: 'sticker',
          packageId: '2',
          stickerId: '144'
        }
      ]).then(function () {
        _this.closeWindow()
        console.log('Message sent')
      }).catch(function (error) {
        console.log('Error sending message: ' + error)
      })
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    },
    getProfile_dev () {
      this.profile = {
        'displayName': 'Pamorn Trivorrarat',
        'pictureUrl': 'https://profile.line-scdn.net/0hehdTyqPSOkdZLRSQHV5FEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
        'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
        'userId': 'U691b2080970333bbeb4930dadc6618b6'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue